module.exports = __webpack_public_path__ + "static/media/logo_login_siv.39bb2ed9.png";